interface Props {
    checked: boolean;
    onChange: () => void;
}

export default function OwnerProposalTHead({checked, onChange}: Props) {
    return (
        <thead>
            <tr className="border-b border-gray-200 bg-[#f8fbfd]">
                <th className="w-10 px-3 py-2.5 text-left">
                    <button
                        type="button"
                        onClick={onChange}
                        aria-label={checked ? "Unselect all proposals" : "Select all proposals"}
                        aria-pressed={checked}
                        className={`flex h-3.5 w-3.5 items-center justify-center rounded border transition ${
                            checked
                                ? "border-[#186cb2] bg-[#186cb2] text-white"
                                : "border-gray-300 bg-white text-transparent hover:border-[#186cb2]"
                        }`}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="h-3 w-3">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m5 12 4 4L19 6" />
                        </svg>
                    </button>
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    Proposal
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    GROUP NAME
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    Product
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    Type
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    Status
                </th>
                <th className="px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    PREPARED BY
                </th>
            </tr>
        </thead>
    )
}
